import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
  Typography,
  makeStyles
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    minWidth: 400,
    padding: theme.spacing(3)
  },
  textField: {
    marginBottom: theme.spacing(2)
  }
}));

// Códigos de país más comunes
const countryCodes = [
  { code: "+1", country: "Estados Unidos/Canadá" },
  { code: "+52", country: "México" },
  { code: "+57", country: "Colombia" },
  { code: "+54", country: "Argentina" },
  { code: "+56", country: "Chile" },
  { code: "+51", country: "Perú" },
  { code: "+58", country: "Venezuela" },
  { code: "+593", country: "Ecuador" },
  { code: "+591", country: "Bolivia" },
  { code: "+595", country: "Paraguay" },
  { code: "+598", country: "Uruguay" },
  { code: "+34", country: "España" },
  { code: "+55", country: "Brasil" },
];

const NewWhatsAppMessageModal = ({ open, onClose }) => {
  const classes = useStyles();
  const [countryCode, setCountryCode] = useState("+57");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    try {
      // Validar campos
      if (!phoneNumber.trim()) {
        toast.error("Por favor ingresa un número de teléfono");
        return;
      }

      if (!message.trim()) {
        toast.error("Por favor ingresa un mensaje");
        return;
      }

      setLoading(true);

      // Construir número completo
      const fullNumber = `${countryCode}${phoneNumber.replace(/\D/g, "")}`;

      // Enviar mensaje
      await api.post("/messages/send", {
        number: fullNumber,
        body: message
      });

      toast.success("Mensaje enviado exitosamente");
      handleClose();
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error(error.response?.data?.error || "Error al enviar el mensaje");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCountryCode("+57");
    setPhoneNumber("");
    setMessage("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Enviar Mensaje de WhatsApp</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Envía un mensaje a un número que no te ha escrito
        </Typography>

        <Grid container spacing={2} style={{ marginTop: 16 }}>
          <Grid item xs={4}>
            <TextField
              select
              fullWidth
              variant="outlined"
              label="Código"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
              className={classes.textField}
            >
              {countryCodes.map((option) => (
                <MenuItem key={option.code} value={option.code}>
                  {option.code} {option.country}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={8}>
            <TextField
              fullWidth
              variant="outlined"
              label="Número de teléfono"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="3001234567"
              className={classes.textField}
              helperText="Solo números, sin espacios ni guiones"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label="Mensaje"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Escribe tu mensaje aquí..."
              className={classes.textField}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleSend}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Enviando..." : "Enviar Mensaje"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewWhatsAppMessageModal;
